import classNames from "classnames";
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import { ReactComponent as AddContract } from "../../../assets/svg/AddContract.svg";
import { ReactComponent as HarazAd } from "../../../assets/svg/HarazAd.svg";
import PrimaryButton from "../../../components/common/PrimaryButton/PrimaryButton";
import Spinner from "../../../components/common/Spinner/Spinner";
import TextInput from "../../../components/forms/textInput";
import styles from "./newTransaction.module.scss";

interface Props {
  handleHarajad: (harajLink: string) => void;
  handleClose: () => void;
  loading: boolean;
}

const ChoiceForm = ({
  handleHarajad,
  handleClose,
  loading,
}: Props): JSX.Element => {
  const [showHarazInput, setShowHarazInput] = useState<boolean>(false);
  const [harajLink, setHarajLink] = useState<string>("");

  const { t } = useTranslation();

  const toggleHaraz = useCallback(() => {
    setShowHarazInput(!showHarazInput);
  }, [showHarazInput]);

  const addFormDetails = useCallback(() => {
    if (harajLink && harajLink !== "") handleHarajad(harajLink);
  }, [handleHarajad, harajLink]);

  const renderHaraz = useCallback(() => {
    return (
      <div className={styles.haraz_container}>
        <div className={styles.haraz_form}>
          <HarazAd />
          <h3>{t("lbl_enter_product_link")}</h3>
          <TextInput
            placeholder={t("lbl_product_link")}
            required={true}
            label={t("lbl_product_link")}
            defaultValue={harajLink}
            handleChange={(e) => setHarajLink(e?.target?.value)}
          />
          <PrimaryButton
            disabled={harajLink === ""}
            id={`create_haraz_contract`}
            onClick={addFormDetails}>
            {loading ? (
              <p>
                <Spinner />
              </p>
            ) : (
              <p className={classNames(styles.subtitle1, styles.white)}>
                {t("lbl_construction")}
              </p>
            )}
          </PrimaryButton>
        </div>
      </div>
    );
  }, [addFormDetails, harajLink, loading, t]);

  const renderCards = useCallback(() => {
    return (
      <div className={styles.choice_form}>
        <div
          onClick={handleClose}
          className={classNames(styles.card, styles.pointer)}>
          <AddContract />
          <h3>{t("lbl_create_new_transaction")}</h3>
          <p className={classNames(styles["p2"], styles["g600"])}>
            {t("lbl_product_service_and_price")}
          </p>
        </div>
        <div
          onClick={toggleHaraz}
          className={classNames(styles.card, styles.pointer)}>
          <HarazAd />
          <h3>{t("lbl_create_transaction_by_haraz")}</h3>
          <p className={classNames(styles["p2"], styles["g600"])}>
            {t("lbl_create_transaction_by_haraz_desc")}
          </p>
        </div>
      </div>
    );
  }, [handleClose, t, toggleHaraz]);

  return <>{showHarazInput ? <>{renderHaraz()}</> : <>{renderCards()}</>}</>;
};

export default ChoiceForm;
